import {makeStyles} from 'external/material'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    padding: '15px 20px',
    borderBottom: 'solid 1px #aab7bf',
    color: '#69748a',
    '& .saveToBank': {
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: '12pt',
      color: '#2ca5ec',
      cursor: 'pointer',
      '& span': {
        ...verticalCentering
      },
      '& svg': {
        marginRight: 5,
        ...verticalCentering
      }
    }
  },
  questionName: {
    display: 'flex',
    flexGrow: 1,
    '& > .label': {
      ...verticalCentering,
      fontSize: '13pt',
      fontWeight: 'bold'
    },
    '& .indexLabel': {
      fontSize: '12.5pt'
    },
    '& > .title': {
      flexGrow: 1,
      display: 'flex',
      marginLeft: 8,
      paddingRight: 10,
      fontSize: '12.5pt',
      '& > div': {
        display: 'flex',
        flexDirection: 'column'
      },
      '& > .title': {
        justifyContent: 'center'
      },
      '& > .icon': {
        marginLeft: 5,
        fontSize: '10pt',
        justifyContent: 'flex-start',
        cursor: 'pointer'
      },
      "& .inputTitle": {
        '& > .control': {
          display: 'flex',
        },
        '& .input': {
          border: 'none',
          borderBottom: '1px solid #69748a',
          color: '#69748a',
          '&:focus': {
            outline: 'none'
          }
        },
        '& .addornment': {
          cursor: 'pointer',
          borderBottom: '1px solid #69748a',
        }
      },

    }
  },
  content: {
    padding: '20px 30px',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    '& > .standards': {
      marginTop: 10,
      marginBottom: 20,
    },
    '& > .top-properties': {
      display: 'flex',
      '& > .value-wrapper': {
          display: 'flex',
          justifyContent: 'flex-end',
          '& > .value-container': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            '& .value-disclaimer': {
              fontSize: '9pt',
              color: '#2ca5ec'
            },
            '& > .value': {
              width: 75,
              '& > .valueLabel': {
                color: '#4e566b'
              },
              '& > .valueInput': {
                display: 'flex',
                borderRadius: 4,
                cursor: 'text',
                padding: 4,
                "& .MuiInput-underline:before": {
                  borderBottom: "none"
                }
              },
            },
        }
      }
    }
  },
  filler: {
    flexGrow: 1
  }
}))

export {useStyles as default}
